var Signals        = require("enyo/Signals"),
    kind           = require("enyo/kind"),
    pageVisibility = require("enyo/pageVisibility");

/**
 * [SliderAutoplaySupport]{@link app.ui.SliderAutoplaySupport} makes
 * [Slider]{@link enyo-ui.Slider} autoplay unless hovered.
 *
 * @mixin     app.ui.SliderAutoplaySupport
 * @requires  enyo-ui.HoverSupport
 * @public
 */
module.exports = {

    /**
     * @memberof  app.ui.SliderAutoplaySupport
     * @private
     */
    slideShowTimer: null,

    /**
     * @memberof  app.ui.SliderAutoplaySupport
     * @private
     */
    observers: {
        toggleSlideShow: ["absoluteShowing", "onvisibilitychange"]
    },

    /**
     * The amount of milliseconds between a slide change
     *
     * @name      slideShowTimeout
     * @type      {number}
     * @memberof  app.ui.SliderAutoplaySupport
     * @public
     */

    /**
     * @memberof  app.ui.SliderAutoplaySupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.slideShowNext = this.bindSafely(this.slideShowNext);
            sup.apply(this, arguments);

            // Duck-punching that thing... for some reason it won't work the
            // documented way.
            Signals.addListener(this);

            // Default to 5 second timeout between slides
            if (this.slideShowTimeout === undefined) {
                this.slideShowTimeout = 5000;
            }
        };
    }),

    /**
     * Starts slideshow if control is absoluteShowing and is not hovered.
     * Stops slideshow if control is hovered or not absoluteShowing.
     *
     * @memberof  app.ui.SliderAutoplaySupport
     * @method
     * @private
     */
    toggleSlideShow: function() {
        var absoluteShowing = this.absoluteShowing,
            isHovered       = this.isHovered(),
            slideShowTimer  = this.slideShowTimer;

        if (absoluteShowing && !isHovered && !pageVisibility.hidden) {
            !slideShowTimer && this.slideShowStart();
        }
        else if (!absoluteShowing || isHovered || pageVisibility.hidden) {
            slideShowTimer && this.slideShowStop();
        }
    },

    /**
     * Starts cycling through slides.
     *
     * @memberof  app.ui.SliderAutoplaySupport
     * @method
     * @public
     */
    slideShowStart: function() {
        this.slideShowTimer = setTimeout(this.slideShowNext, this.slideShowTimeout);
    },

    /**
     * Slides to next slide and sets a new timeout for the next slide.
     *
     * @memberof  app.ui.SliderAutoplaySupport
     * @method
     * @private
     */
    slideShowNext: function() {
        this.transitionToNext();
        this.slideShowTimer = setTimeout(this.slideShowNext, this.slideShowTimeout);
    },

    /**
     * Stops cycling through slides.
     *
     * @memberof  app.ui.SliderAutoplaySupport
     * @method
     * @public
     */
    slideShowStop: function() {
        this.slideShowTimer && clearTimeout(this.slideShowTimer);
        this.slideShowTimer = null;
    }

};
